<template>
  <ReportBaseSelectFilter
    class="activity-level-filter"
    label="Activity Level"
    placeholder="All levels"
    query-property="activity_level"
    :options="activityLevelOptions"
    :multiple="false"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportActivityLevelFilter',
  computed: {
    ...mapGetters(['activityLevelOptions']),
  },
};
</script>
